<script>
import { mixinJleagueClient } from "./mixin/jleague_client"
import JleagueHeader from './components/JleagueHeader'
import JleagueFooter from './components/JleagueFooter'
import SignupForm from  './components/SignupForm'

export default {
    name: 'Signup',
    components: {
        'jleague-header': JleagueHeader,
        'jleague-footer': JleagueFooter,
        'signup-form': SignupForm,
    },
    mixins: [mixinJleagueClient],
    data() {
        return {}
    },
}
</script>
